'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var Link = require('../../00.helper/Link/Link.js');
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../../01.atoms/Icon/Icon.js');
var MaterialDrop = require('../../01.atoms/MaterialDrop/MaterialDrop.js');
var Expandable = require('../../01.atoms/Expandable/Expandable.js');
var SelectAdvanced = require('../SelectAdvanced/SelectAdvanced.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-side-menu',
    cnSidebar = "".concat(CLASSNAME, "__sidebar"),
    cnTitle = "".concat(CLASSNAME, "__title"),
    cnGroups = "".concat(CLASSNAME, "__groups"),
    cnGroupsWrapperOuter = "".concat(cnGroups, "__wrapper-outer"),
    cnGroupsWrapperInner = "".concat(cnGroups, "__wrapper-inner"),
    cnGroupsScrollBottom = "".concat(cnGroups, "--scroll-bottom"),
    cnSelect = "".concat(CLASSNAME, "__select"),
    cnGroup = "".concat(CLASSNAME, "__group"),
    cnItems = "".concat(CLASSNAME, "__items"),
    cnItem = "".concat(CLASSNAME, "__item"),
    cnItemTitle = "".concat(cnItem, "__title"),
    cnItemTitleActive = "".concat(cnItemTitle, "--active"),
    cnItemBadge = "".concat(cnItem, "__badge"),
    cnLink = "".concat(CLASSNAME, "__link"),
    cnGroupTitle = "".concat(cnGroup, "__title"),
    cnHome = "".concat(CLASSNAME, "__home"),
    cnHomeButton = "".concat(cnHome, "__button"),
    cnHomeIcon = "".concat(cnHome, "__icon");
/**
 * @class SideMenu
 * The menu displayed on all tool pages (desktop only)
 */

var SideMenu = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(SideMenu, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(SideMenu);

  function SideMenu() {
    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, SideMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "state", {
      animationState: []
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onScroll", function (e) {
      if (_this.timeout) {
        window.clearTimeout(_this.timeout);
      }

      var target = e.target;
      _this.timeout = window.setTimeout(function () {
        _this.onScrollEnd(target);
      }, 100);
    });

    return _this;
  }

  _rollupPluginBabelHelpers.createClass(SideMenu, [{
    key: "onScrollEnd",
    value: function onScrollEnd(target) {
      var scrollBottom = target.offsetHeight + target.scrollTop >= target.firstElementChild.offsetHeight;
      this.setState({
        scrollBottom: scrollBottom
      });
    }
    /**
     * Renders group of menu items
     * @param {Array} items
     * @param {String} animated
     * @param {String} index
     * @returns {HTMLElement}
     */

  }, {
    key: "renderItems",
    value: function renderItems(items, animated, index) {
      var _this2 = this;

      var _onClick = this.props.onClick;
      var animationState = this.state.animationState;

      if (items.length && animated && !animationState[index] && typeof window !== 'undefined') {
        window.setTimeout(function () {
          animationState[index] = 'in';

          _this2.setState({
            animationState: _rollupPluginBabelHelpers.toConsumableArray(animationState)
          });
        }, 32);
      }

      return items.map(function (group) {
        var _group$items;

        return /*#__PURE__*/React__default.createElement(React.Fragment, {
          key: group.id
        }, group.displayOption !== 'select' ? /*#__PURE__*/React__default.createElement(Expandable, {
          expanded: animationState[index] === 'in' || !animated,
          key: group.id
        }, /*#__PURE__*/React__default.createElement("div", {
          className: classNames(cnGroup, group.className)
        }, group.title && /*#__PURE__*/React__default.createElement("h4", {
          className: cnGroupTitle
        }, group.title), group.widget, /*#__PURE__*/React__default.createElement("ul", {
          className: cnItems
        }, (_group$items = group.items) === null || _group$items === void 0 ? void 0 : _group$items.map(function (item) {
          return /*#__PURE__*/React__default.createElement("li", {
            key: item.title,
            className: classNames(cnItem, item.className, _rollupPluginBabelHelpers.defineProperty({}, item.classNameActive, item.active && item.classNameActive))
          }, /*#__PURE__*/React__default.createElement(Link, {
            className: cnLink,
            disabled: item.disabled,
            link: item.link || '/',
            onClick: function onClick(e) {
              _onClick(e, group.id, item);

              if (item.onClick) {
                item.onClick(e, group.id, item);
              }
            }
          }, /*#__PURE__*/React__default.createElement("span", {
            className: classNames(cnItemTitle, _rollupPluginBabelHelpers.defineProperty({}, cnItemTitleActive, item.active))
          }, item.title), item.notifications ? /*#__PURE__*/React__default.createElement("span", {
            className: cnItemBadge
          }, item.notifications) : null));
        })))) : /*#__PURE__*/React__default.createElement(SelectAdvanced, {
          value: group.defaultValue,
          checkbox: false,
          className: cnSelect,
          onChange: group.onChange,
          options: group.items
        }));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          items = _this$props.items,
          itemsTop = _this$props.itemsTop,
          itemsBottom = _this$props.itemsBottom,
          innerRef = _this$props.innerRef,
          animated = _this$props.animated,
          title = _this$props.title,
          mobile = _this$props.mobile,
          labelHomepage = _this$props.labelHomepage,
          homeLink = _this$props.homeLink,
          locale = _this$props.locale,
          bottomWidget = _this$props.bottomWidget;
      var scrollBottom = this.state.scrollBottom;

      if (mobile) {
        return null;
      }

      return /*#__PURE__*/React__default.createElement("aside", {
        ref: innerRef,
        className: classNames(CLASSNAME)
      }, /*#__PURE__*/React__default.createElement("div", {
        className: cnSidebar
      }, /*#__PURE__*/React__default.createElement("h2", {
        className: cnTitle
      }, title), /*#__PURE__*/React__default.createElement("div", {
        className: classNames(cnGroups, _rollupPluginBabelHelpers.defineProperty({}, cnGroupsScrollBottom, scrollBottom))
      }, /*#__PURE__*/React__default.createElement("div", {
        className: cnGroupsWrapperOuter,
        onScroll: this.onScroll
      }, /*#__PURE__*/React__default.createElement("div", {
        className: cnGroupsWrapperInner
      }, this.renderItems(itemsTop, animated, 0), this.renderItems(items, false, 1), this.renderItems(itemsBottom, animated, 2)))), /*#__PURE__*/React__default.createElement("div", {
        className: cnHome
      }, bottomWidget, /*#__PURE__*/React__default.createElement(Link, {
        link: "".concat(homeLink, "/").concat(locale),
        className: cnHomeButton
      }, /*#__PURE__*/React__default.createElement(Icon, {
        id: "home",
        size: "sm",
        className: cnHomeIcon
      }), labelHomepage, /*#__PURE__*/React__default.createElement(MaterialDrop, null)))));
    }
  }]);

  return SideMenu;
}(React__default.Component);
SideMenu.propTypes = {
  /** Show new items animated */
  animated: PropTypes.bool,

  /** Widget at the bottom */
  bottomWidget: PropTypes.element,

  /** URL to home */
  homeLink: PropTypes.string,

  /** Ref of inner element */
  innerRef: PropTypes.any,

  /** default items */
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    items: PropTypes.array,
    displayOption: PropTypes.string
  })),

  /** Items below default items */
  itemsBottom: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    items: PropTypes.array,
    displayOption: PropTypes.string
  })),

  /** Items above default items */
  itemsTop: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    items: PropTypes.array,
    displayOption: PropTypes.string
  })),

  /** Label for home link */
  labelHomepage: PropTypes.string.isRequired,

  /** Current language locale */
  locale: PropTypes.string,

  /** True for mobile styling */
  mobile: PropTypes.bool,

  /** Callback function */
  onClick: PropTypes.func,

  /** Title of SideMenu */
  title: PropTypes.string
};
SideMenu.defaultProps = {
  items: [],
  itemsTop: [],
  itemsBottom: [],
  onClick: function onClick() {
    return void 0;
  }
};

module.exports = SideMenu;
